import z from "zod";

// 타입 정의
export const RadioValueSchema = z.enum(["thisMonth", "lastMonth", "threeMonths", "sixMonths", "oneYear", "manual"]);
export type RadioValue = z.infer<typeof RadioValueSchema>;

const dateFormat = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD 정규식


// 타입 선언
export const searchDateFormParamsSchema = z.object({
  startDate: z.string({ message: "startDate는 문자열 이어야 합니다." }).regex(dateFormat, { message: "startDate는 YYYY-MM-DD 형식이어야 합니다" }),
  endDate: z.string({ message: "endDate는 문자열 이어야 합니다." }).regex(dateFormat, { message: "endDate는 YYYY-MM-DD 형식이어야 합니다" }),
  dateRadioValue: RadioValueSchema.optional(),
});

export type SearchDateFormParams = z.infer<typeof searchDateFormParamsSchema>;

export type InitValues =
  | { dateRadioValue: "manual"; startDate: string; endDate: string }
  | {
      dateRadioValue: Exclude<RadioValue, "manual">;
    };
